import { View, ViewModel } from "binder";
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { ServerConnection } from "src/server/serverConnection";

export class MeasureParameterGroupSelector extends SelectorBaseViewModel<MeasureParameterGroup>{
    public getTypeId(): string {return '';}
    constructor(parent:ViewModel, isContainChildren = true) {
        super(parent);
        this.isContainChildren = isContainChildren;    
    }
    
    public set isContainChildren(v: boolean) { this._isContainChildren = v; } public get isContainChildren(): boolean { return this._isContainChildren;} private _isContainChildren: boolean;
    
    protected async loadData(): Promise<MeasureParameterGroup[]> {
        let result = await ServerConnection.callServer('/Complex/ControlPlanService/GetAllMeasureParameterGroups',{
            IsContainChildren : this.isContainChildren
        });

        return result.Groups.map(x=> {
            let measureParameterGroup:MeasureParameterGroup = new MeasureParameterGroup(this);
            measureParameterGroup.id = x.Id;
            measureParameterGroup.title = x.Name;
            measureParameterGroup.name = x.Name;
            return measureParameterGroup;
        });
    }
    
}

export class MeasureParameterGroup extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
}